import { GenericCardListPage } from 'src/Features/GenericCardListPage/GenericCardListPage'
import { SortOrder } from 'src/Types/SortOrder'

import { AppPage } from 'src/Types/AppPage'

export const SwitchesAndHeatCardsPage = () => {
  return <GenericCardListPage route={AppPage.SwitchesAndHeatCards} defaultSortOrder={SortOrder.Alphabetical} />
}
